import React from 'react';
import { FormattedMessage, useIntl } from '../../util/reactIntl';
import { ExternalLink, LinkedLogo, NamedLink, PrimaryButton } from '../../components';
import Icons from '../../components/Icons/Icons';

import css from './FooterContainer.module.css';

function FooterContainer(props) {
  const intl = useIntl();

  const socialLinks = [
    { href: 'https://www.facebook.com', icon: 'facebook', label: 'Facebook' },
    { href: 'https://www.instagram.com', icon: 'instagram', label: 'Instagram' },
    { href: 'https://www.linkedin.com', icon: 'linkedin', label: 'LinkedIn' },
  ];

  const companyLinks = [
    { name: 'LandingPage', text: 'About' },
    { name: 'LandingPage', text: 'Team' },
    { name: 'LandingPage', text: 'Blog' },
    { name: 'LandingPage', text: 'Contact' },
  ];

  const productLinks = [
    { name: 'LandingPage', text: 'Overview' },
    { name: 'LandingPage', text: 'Features' },
    { name: 'LandingPage', text: 'Solutions' },
    { name: 'LandingPage', text: 'Pricing' },
  ];
  const customerSupportLinks = [
    { name: 'LandingPage', text: 'Shipping FAQ' },
    { name: 'LandingPage', text: 'Trust and Safety' },
    { name: 'LandingPage', text: 'Buyer Protection' },
    // { name: 'LandingPage', text: 'Help Center' },
  ];

  const otherLinks = [
    { href: '/privacy-policy', text: 'Privacy Policy' },
    { href: '/terms-of-service', text: 'Terms and Conditions' },
  ];

  return (
    <div className={css.footer}>
      <div className={css.footerTop}>
        <div className={css.contentWidth}>
          <div className={css.leftBlock}>
            <div className={css.linksBlock}>
              <NamedLink
                className={css.logo}
                name="LandingPage"
                title={intl.formatMessage({ id: 'Topbar.logoIcon' })}
              >
                <LinkedLogo />
              </NamedLink>
              <p>
                <FormattedMessage id="Footer.guidedByHeart" />
              </p>
              {/*<div className={css.socialLinks}>
                {socialLinks.map(link => (
                  <ExternalLink
                    key={link.icon}
                    href={link.href}
                    className={css.link}
                    aria-label={link.label}
                  >
                    <Icons name={link.icon} />
                  </ExternalLink>
                ))}
              </div>*/}
            </div>
          </div>
          <div className={css.rightBlock}>
            {/*<FooterLinksBlock
              title={intl.formatMessage({ id: 'Footer.companyTitle' })}
              links={companyLinks}
            />
            <FooterLinksBlock
              title={intl.formatMessage({ id: 'Footer.productTitle' })}
              links={productLinks}
            />*/}
            <FooterLinksBlock
              title={intl.formatMessage({ id: 'Footer.customerTitle' })}
              links={customerSupportLinks}
            />

            <FooterLinksBlock
              title={intl.formatMessage({ id: 'Footer.otherTitle' })}
              links={otherLinks}
              external
            />
          </div>
        </div>
      </div>
      <div className={css.footerMiddle}>
        <div className={css.contentWidth}>
          <div className={css.footerBottomLeft}>
            <p>{intl.formatMessage({ id: 'Footer.FooterText' })}</p>
          </div>
        </div>
      </div>
      <div className={css.footerBottom}>
        <div className={css.contentWidth}>
          <div className={css.footerBottomLeft}>
            <p>Get the best deals in your inbox</p>
            <div className={css.subscribeNow}>
              <input type="email" placeholder="Enter your email" />
              <PrimaryButton>Subscribe</PrimaryButton>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function FooterLinksBlock({ title, links, external }) {
  return (
    <div className={css.linksBlock}>
      <h2>{title}</h2>
      {links.map((link, index) =>
        external ? (
          <ExternalLink key={index} href={link.href} className={css.link}>
            {link.text}
          </ExternalLink>
        ) : (
          <NamedLink key={index} className={css.link} name={link.name}>
            {link.text}
          </NamedLink>
        )
      )}
    </div>
  );
}

export default FooterContainer;
